import {
  Component,
  computed,
  HostListener,
  inject,
  OnInit,
  signal,
} from '@angular/core';
import { RouterModule, Router } from '@angular/router';
import { CommonModule } from '@angular/common';
import { AuthService } from 'src/app/Services/auth/auth.service';
import { StateService } from 'src/app/Services/state/state.service';
import { ModalController, Platform } from '@ionic/angular/standalone';
import { environment } from 'src/environments/environment';
import { Browser } from '@capacitor/browser';
import { ContactUsComponent } from '../contact-us/contact-us.component';
import { TranslateModule } from '@ngx-translate/core';
import { LanguageComponentComponent } from '../language-component/language-component.component';
import { take } from 'rxjs';
import { LoginUser } from 'src/app/models/user.model';
import { PhoneFormatPipe } from 'src/app/shared/pipes/phone-format.pipe';
import { App } from '@capacitor/app';
import { Capacitor } from '@capacitor/core';

@Component({
  selector: 'app-sidebar',
  templateUrl: './sidebar.component.html',
  styleUrls: ['./sidebar.component.scss'],
  standalone: true,
  imports: [
    RouterModule,
    CommonModule,
    TranslateModule,
    LanguageComponentComponent,
    PhoneFormatPipe,
  ],
})
export class SidebarComponent implements OnInit {
  private router = inject(Router);
  private authService = inject(AuthService);
  private modalCtrl = inject(ModalController);
  private stateService = inject(StateService);
  platform = inject(Platform);

  modalController = inject(ModalController);
  screenWidth = signal(window.innerWidth);
  isMobile = computed(() => (this.screenWidth() <= 1023 ? true : false));

  environment: any = environment;
  logoUrl = '';

  currentRoute: string = this.router.url;

  currentRole = signal(this.authService.getCurrentRole());
  userInfo = computed(() => this.stateService.userInfo() as LoginUser | null);

  constructor() {}

  version = 'Unknown';
  build = 'Unknown';

  async ngOnInit() {
  if (!Capacitor.isNativePlatform()) {
    this.version = environment.appVersion;
    this.build = environment.buildNumber;
    return;
  }

  try {
    const info = await App.getInfo();
    this.version = info.version ?? 'Unknown';
    this.build = info.build?.toString() ?? 'Unknown';
  } catch (err) {
    console.error('Error getting app version', err);
  }
}

  openProfile() {
    this.router.navigate(['/profile'], { replaceUrl: true });
    this.modalController.dismiss();
  }

  @HostListener('window:resize', ['$event'])
  onResize(event: any) {
    this.screenWidth.set(event.target.innerWidth);
  }

  logout() {
    this.authService
      .logout()
      .pipe(take(1))
      .subscribe({
        next: () => {
          this.router.navigate(['/login'], { replaceUrl: true });
          this.modalController.dismiss();
        },
        error: (err) => {
          console.error('Logout failed:', err);
        },
        complete: () => this.stateService.clearUser(), // Clear user info on logout
      });
  }
  async OpenUrl(url: string) {
    await Browser.open({ url: url });
    this.modalController.dismiss();
  }
  async OpenContactUsPage(url: string) {
    const modal = await this.modalCtrl.create({
      component: ContactUsComponent,
      breakpoints: [0, 0.5, 0.7, 0.85, 0.95],
      initialBreakpoint: 0.95,
      backdropDismiss: true,
      canDismiss: true,
    });

    modal.present();
    modal.onDidDismiss().then(() => {
      this.modalController.dismiss();
    });
  }
  dismiss() {
    this.modalController.dismiss();
  }
}
